import React from 'react';

const AppFeatures: React.FC = () => {
  const features = [
    {
      icon: "🏘️",
      title: "Mạng lưới hàng xóm",
      description: "Kết nối với những người sống gần bạn, xây dựng mối quan hệ bền vững trong cộng đồng."
    },
    {
      icon: "🛒",
      title: "Chợ trời số",
      description: "Mua bán dễ dàng với hàng xóm, từ đồ cũ đến thực phẩm tươi ngon."
    },
    {
      icon: "🎉",
      title: "Sự kiện cộng đồng",
      description: "Tham gia các hoạt động thú vị, từ thể thao đến văn hóa trong khu vực."
    },
    {
      icon: "👥",
      title: "Nhóm sở thích",
      description: "Tìm những người có cùng đam mê, từ nấu ăn đến thể thao."
    }
  ];

  return (
    <section className="bg-white rounded-xl md:rounded-2xl shadow-lg p-4 md:p-6 mb-6 md:mb-8">
      <h2 className="text-xl md:text-2xl font-bold text-black mb-4 md:mb-6">Tính năng nổi bật</h2>
      <div className="grid sm:grid-cols-2 gap-4 md:gap-6">
        {features.map((feature, index) => (
          <div key={index} className="flex gap-4">
            <div className="w-12 h-12 bg-gray-100 rounded-xl flex items-center justify-center flex-shrink-0">
              <span className="text-2xl">{feature.icon}</span>
            </div>
            <div>
              <h3 className="font-semibold text-black mb-2">{feature.title}</h3>
              <p className="text-gray-600 text-sm">{feature.description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default AppFeatures;
